// polyfills need for IE 11
require('core-js/es/object');

// Some dependencies assume a Node-like `process` global exists.
// WKWebView does not provide it, and webpack shims can miss cases depending on bundling.
// Provide a minimal browser-safe shim early in the entrypoint.
if (typeof globalThis !== 'undefined' && typeof globalThis.process === 'undefined') {
  globalThis.process = { env: {}, browser: true };
}